export type FlowGroupId = 'informed' | 'whales';

export interface FlowGroup {
    id: FlowGroupId;
    label: string;
    color: string;
}

export const FLOW_GROUPS: readonly FlowGroup[] = [
    { id: 'informed', label: 'Informed', color: '#f59e0b' },
    { id: 'whales', label: 'Whales', color: '#3b82f6' },
];

export const FLOW_GROUP_IDS: readonly FlowGroupId[] = FLOW_GROUPS.map(
    g => g.id
);

export function flowGroup(id: FlowGroupId): FlowGroup {
    return FLOW_GROUPS.find(g => g.id === id) ?? FLOW_GROUPS[0];
}

export interface FlowPoint {
    t: number;
    netCapital: number;
    capitalYes: number;
    capitalNo: number;
    wallets: number;
}

export interface LatestFlow {
    netCapital: number;
    capitalYes: number;
    capitalNo: number;
    wallets: number;
    ts: number | null;
}

export type FlowByGroup = ReadonlyMap<FlowGroupId, readonly FlowPoint[]>;

export type LatestFlowByMarket = ReadonlyMap<
    string,
    ReadonlyMap<FlowGroupId, LatestFlow>
>;

export function hasFlow(flow: LatestFlow | undefined): boolean {
    return (
        flow !== undefined &&
        (flow.wallets > 0 || flow.capitalYes > 0 || flow.capitalNo > 0)
    );
}
